import {useState, useEffect} from 'react';
import { changeDisable, setMaskDecimal, getPermission, showMessageError } from '../../../classes/functions';
import download from 'downloadjs';
import axios from 'axios';
import baseUrl from '../../../baseUrl.js';
import './tags.css';
import Modal from 'react-modal';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaCog, FaArrowAltCircleLeft } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    width: '700px',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export default function Tags(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);
  const [modalPrintTags, setModalPrintTags] = useState(false);

  const [tipo, setTipo] = useState('');
  const [quantidade, setQuantidade] = useState('');

  const [de, setDe] = useState('');
  const [ate, setAte] = useState('');

  const [mensagemModal, setMensagemModal] = useState('');
  
  useEffect(()=> {
    async function loadTags(){
      if (id) {
        getOne(id, option);
      } 
    }

    loadTags();
    setCarrying(false);

  },[]);

  function validForm() {
    if ((tipo != '') && (quantidade != '')) {
      return true;
    } else {
      toast.error('Preencha todos os campos com * antes de gerar as etiquetas.');
      return false;
    }
  }

  function save(e){
    setCarrying(true);
    e.preventDefault();

    if (!validForm()) {
      setCarrying(false);
      return false;
    }
    
    const data = {
      row: {
        tipo: tipo,
        quantidade: quantidade,
        format: 'default',
      }
    }

    if (id) { 
      data.row.id = id;
      api.put("/api/tags/put", data)
      .then((response) => {
          toast.success('Registro atualizado com sucesso.');
          if (getPermission('OPERACOES - EIQUETAS - IMPRESSAO')) {
            modalPrintTags(true);
          } else {
            history.push('/tags');
          }
        }
      ).catch((error) => {
        toast.error('Ops! Ocorreu um erro.');
      });
    } else {
      api.post("/api/tags/post", data)
      .then((response) => {
        if (getPermission('OPERACOES - ETIQUETAS - IMPRESSAO')) {
          setCarrying(false);
          setMensagemModal(`Gerado da etiqueta ${response.data.first} à ${response.data.last}.`);

          setDe(response.data.first);
          setAte(response.data.last);

          openModal();
          // toast.success('Registro inserido com sucesso.');
          // history.push('/tags');
        } else {
          history.push('/tags');
        }
        
      }).catch((error) => {
        setCarrying(false);
        toast.error('Ops! Ocorreu um erro.');
      });
    }
  }

  function getOne(id, option){
    api.get("/api/tags/getList?id=" + id)
    .then((response) => {
        
      }
    ).catch((error) => {
      toast.error('Ops! Ocorreu um erro.');
    });

    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/tags');
  }

  function remove(){
    api.delete("/api/tags/delete?id=" + id)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/tags');
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function print () {
    setCarrying(true);
    axios.get(
      baseUrl + "api/tags/printInterval?de=" + de + "&ate=" + ate, 
      {responseType: 'blob',
      headers: {
        empresa: localStorage.empresa,
        usuario: localStorage.usuario
      }} 
    ).then((response) => {      
      const content = response.headers['content-type'];
      download(response.data, 'etiquetas.pdf', content);
      toast.success('Etiquetas impressas com sucesso.');
      history.push('/tags');
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  function openModal () {
    setModalPrintTags(true);
  }

  function closeModal () {
    setModalPrintTags(false);
    toast.success('Etiquetas geradas com sucesso.');
    history.push('/tags');
  }

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
            
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Etiquetas">
          <Link to="/tags">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados</h2>
              <hr></hr>
            <div className="divGroup">
              <div className="formDiv">
                <label>Tipo</label>&nbsp;<label className="required">*</label><br/>
                <select value={tipo} onChange={ (e) => setTipo(e.target.value) } disabled={view}>
                  <option value="">Selecione</option>
                  <option value="P">Palete</option>
                </select>
              </div>
            </div>
            <div className="divGroup">
              <div className="formDiv">
                <label>Quantidade</label>&nbsp;<label className="required">*</label><br/>
                <input type="text" placeholder="Quantidade" value={quantidade} onChange={ (e) => setQuantidade(setMaskDecimal(e.target.value, 0)) } disabled={view}/>
              </div>
            </div>
            </div>
            {!view && <div className="formDiv">
              {getPermission('OPERACOES - ETIQUETAS - CADASTRO') && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
            </div>}
          </form>
        </div>
      </div>}

      <Modal  
        isOpen={modalPrintTags}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Tags"
        ariaHideApp={false}
      >
        <div className="modal-print">
          <div className=" formDiv modal-print__titles">
            <h2 className="modal-print___title">Etiquetas geradas com sucesso.</h2><br/>
            <h2 className="modal-print___title">{mensagemModal}</h2><br/><br/>
            <h2 className="modal-print___title">Deseja imprimir as etiquetas?</h2><br/>
          </div>
          <div className="formDiv modal-print__buttons">
            <button type="button" className="modal-print___button" onClick={print}>Imprimir</button>
            <button type="button" className="modal-print___button" id="button-close" onClick={closeModal}>Fechar</button>
          </div>
        </div>
      </Modal>
    </div>
  )
}